module.exports = "/_next/static/images/TeamPlan-sm@2x-4da26738e468b97b9387d4d1bbc0ee35.webp";